import React from 'react';
import ShadedBlock from 'components/shadedBlock';
import { SwalWrapper } from 'components/swal';
import { Intent } from 'constants/ui';
import { convertSupportedMimeTypesToExtension } from 'helpers/mimeTypes';
const UnsupportedFileTypeSwal = ({ errorMsg }) => (React.createElement(SwalWrapper, { confirmButtonProps: { text: 'Ok' }, subtitle: "The attachment below is not a supported file type. Please upload a new document to continue.", title: "Unsupported filetype" },
    React.createElement(ShadedBlock, { intent: Intent.NEUTRAL }, convertSupportedMimeTypesToExtension(errorMsg))));
export default UnsupportedFileTypeSwal;
